import { render } from "./KioskTelehealth.vue?vue&type=template&id=2b5675e6&scoped=true&ts=true"
import script from "./KioskTelehealth.vue?vue&type=script&lang=ts"
export * from "./KioskTelehealth.vue?vue&type=script&lang=ts"

import "./KioskTelehealth.vue?vue&type=style&index=0&id=2b5675e6&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5675e6"]])

export default __exports__